import { apiInstanceWithToken } from "../integrations/ApiInstance";
import "react-toastify/dist/ReactToastify.css";
import {
  fileEndpoints
} from "../integrations/ApiEndpoints";

import { showErrorToast } from "../utils/Toasts";
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  FILE- START // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 


export const createFamilyFileUploadUrl = async (data,) => {
  try {
    const response = await apiInstanceWithToken.post(fileEndpoints.createFamilyFileUploadUrl, data);
    if (response?.status === 200) {
      return response.data;
    }
    else {
      showErrorToast(response?.message);
      return false;
    }
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "பதிவேற்றத்தை அங்கீகரிக்க முடியவில்லை...." };
  }
};
export const getFamilyFileDownladUrl = async (data) => {
  try {
    const response = await apiInstanceWithToken.post(fileEndpoints.getFamilyFileDownladUrl, data);
    if (response?.status === 200) {
      return response;
    }
    else {
      showErrorToast(response?.message);
      return false;
    }
  } catch (error) {
    console.error(error);
    return { success: false, message: error.response?.data?.message || "பதிவிறக்கத்தை அங்கீகரிக்க முடியவில்லை...." };
  }
};
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  FILE - END // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // 